/**
 * The messages Chromium, Safari and Firefox throw when a lazily loaded route chunk can't be fetched, plus the one
 * Vite throws when the chunk's stylesheet can't be. SvelteKit already reloads the page when the chunk is gone because
 * of a new deployment, so the ones that reach our error handling are the client's connection dropping.
 */
export const CHUNK_LOAD_ERROR =
	/Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/

export function isChunkLoadError(error: unknown): boolean {
	return error instanceof Error && CHUNK_LOAD_ERROR.test(error.message)
}
